import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeListService = (params: Types.EmployeeListRequest) =>
  RestAPIClient.call<Types.EmployeeListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeListShortService = (params: Types.EmployeeListRequest) =>
  RestAPIClient.call<Types.EmployeeListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const employeeDetailService = (id: string) =>
  RestAPIClient.call<Types.Employee>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeCreateService = (params: Types.EmployeeCreateRequest) =>
  RestAPIClient.call<Types.Employee>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeUpdateService = (params: Types.EmployeeUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeImportService = (data: Types.EmployeeImportRequest) =>
  RestAPIClient.call<Types.EmployeeImportResponse>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Import}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const employeeGetTotalService = (params: {
  year?: number;
  month?: number;
  templateId: string;
  payrollTemplateId?: string;
  templatePeriod?: number;
  runWithAdjustment?: boolean;
  cycleId?: string;
}) =>
  RestAPIClient.call<{ total: number }>({
    method: HTTPRequestMethods.GET,
    url: Paths.GetTotalEmployee,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeGetWorkingHistoryService = (param: {
  employeeId: number;
}) =>
  RestAPIClient.call<Types.EmployeeWorkingHistoryResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.WorkingHistory.replace(
      "{employeeId}",
      param.employeeId.toString()
    )}`,
    config: {
      requireAuthentication: true,
    },
  });
